import PropTypes from 'prop-types';
import React from 'react';
import Fade from 'react-reveal';

const Ratings = ({ data }) => {
  if (!data) return null;

  const { articles, ratings, titleArticles, titleRatings } = data;
  const articlesView = articles.map((article) => {
    const { name, url, filename } = article;
    return (
      <div key={name} className="columns portfolio-item">
        <div className="item-wrap cardWithBackground">
          <a href={url} target="_blank" rel="noreferrer">
            <img src={`images/articles/${filename}`} alt={name} />
          </a>
        </div>
      </div>
    );
  });

  const ratingsView = ratings.map((rating) => {
    const { name, message } = rating;
    return (
      <div key={name} className="columns portfolio-item">
        <div className="item-wrap card">
          <blockquote>
            <p>{message}</p>
            <cite>
              <b>{name}</b>
            </cite>
          </blockquote>
        </div>
      </div>
    );
  });

  return (
    <section id="ratings">
      <Fade left duration={1000} distance="40px">
        <div className="row">
          <div className="twelve columns collapsed">
            <h1>{titleRatings}</h1>
            <div className="bgrid-thirds s-bgrid-thirds cf">{ratingsView}</div>
          </div>
          <div className="twelve columns collapsed">
            <h1>{titleArticles}</h1>
            <div className=".align-center">{articlesView}</div>
          </div>
        </div>
      </Fade>
    </section>
  );
};

Ratings.propTypes = {
  data: PropTypes.shape({
    titleRatings: PropTypes.string,
    titleArticles: PropTypes.string,
    ratings: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        message: PropTypes.string,
      }),
    ),
    articles: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        filename: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default Ratings;
